import Markdown from './Markdown.vue'
import { VueConstructor } from 'vue'

export default {
  install(Vue: VueConstructor) {
    // Install a component globally
    Vue.component('markdown', Markdown)
  }
}
